export default "__VITE_PUBLIC_ASSET__30e341ce__"